
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { InputBorderType_Enum } from '../../enums/InputBorderType_Enum'
import { InputType_Enum } from '../../enums/InputType_Enum'
import { TooltipPosition_Enum } from '../../enums/TooltipPosition_Enum'
import CFInput from './CFInput'

	@Component({
	  name: 'InputText'
	})
export default class InputText extends Vue implements CFInput {
		@Prop() id!: string;
		@Prop({ default: '' }) name!: string;
		@Prop({ default: '' }) label!: string;
		@Prop({ default: 'Required' }) errorText!: string;
		@Prop() value!: string | null;
		@Prop({ default: true }) required!: boolean;
		@Prop({ default: 0 }) min!: number;
		@Prop({ default: 256 }) max!: number;
		@Prop({ default: '' }) placeholder!: string;
		@Prop({ default: InputBorderType_Enum.underlined }) borderType!: InputBorderType_Enum;
		@Prop({ default: InputType_Enum.text }) type!: InputType_Enum;
		@Prop({ default: '' }) tooltipText!: string;
		@Prop({ default: TooltipPosition_Enum.left }) tooltipPosition!: TooltipPosition_Enum;
		@Prop({ default: 'under' }) errorPosition!: string;
		@Prop({ default: undefined }) regex!: string;
		@Prop({ default: false }) uppercase!: boolean;

		placeholderTemp = '';

		val: string | null = null;

		valid = true;

		validHtmlTag = true;

		@Watch('value', { immediate: true })
		set () {
		  this.val = this.value
		}

		@Watch('val', { immediate: true, deep: true })
		update () {
		  this.valid = true
		  this.$emit('input', this.val)
		}

		@Watch('placeholder', { immediate: true })
		changePlaceholder () {
		  this.placeholderTemp = this.placeholder
		}

		validate () {
		
			if ((this.val && this.val !== '')) {
				let regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
			
				if(!regexForHTML.test(this.val!) ) {
					this.validHtmlTag = true;
				} else {
					this.validHtmlTag = false;
				}
				return this.validHtmlTag;
			}
			

		  if ((this.val && this.val !== '') || (!this.val && !this.required)) {
		    if (this.regex) {
		      this.valid = new RegExp(this.regex).test(this.val!)
		      return this.valid
		    }

		    this.valid = true
		    return true
		  }

		  if (this.errorPosition === 'in') {
		    this.placeholderTemp = this.errorText
		  }

		  this.valid = false
		  return false
		}

		onBlur () {
		  this.$emit('blur', this.val)
 		}

		focus () {
		  (this.$refs[this.id] as HTMLInputElement).focus()
		}

		get cssClass () {
		  return this.valid ? '' : 'error'
		}

		get prefixSlot () {
		  return this.$slots.prefix
		}

		@Watch('val')
		toUpper () {
		  if (this.uppercase && this.val) {
		    this.val = this.val!.toUpperCase()
		  }
		}
}
